const highlightCodeTheme = {
	lineNumberColor: `#6272a4`,
	lineNumberBgColor: `#282a36`,
	backgroundColor: `#282a36`,
	textColor: `#FFFFFF`,
	substringColor: `#36E79B`,
	keywordColor: `#FF5377`,
	attributeColor: `#FF9457`,
	selectorTagColor: `#8be9fd`,
	docTagColor: `#36E79B`,
	nameColor: `#66d9ef`,
	builtInColor: `#FF9457`,
	literalColor: `#FF5377`,
	bulletColor: `#8BE9FD`,
	codeColor: `#FF9457`,
	additionColor: `#36E79B`,
	regexpColor: `#36E79B`,
	symbolColor: `#36E79B`,
	variableColor: `#FFFFFF`,
	templateVariableColor: `#FF5377`,
	linkColor: `#00bcd4`,
	selectorAttributeColor: `#FF5377`,
	selectorPseudoColor: `#FF5377`,
	typeColor: `#8BE9FD`,
	stringColor: `#36E79B`,
	selectorIdColor: `#FF9457`,
	selectorClassColor: `#FF9457`,
	quoteColor: `#E9F284`,
	templateTagColor: `#FF5377`,
	deletionColor: `#FF5377`,
	titleColor: `#ff5580`,
	sectionColor: `#FFFFFF`,
	commentColor: `#6272A4`,
	metaKeywordColor: `#FF9457`,
	metaColor: `#FF9457`,
	functionColor: `#FF9457`,
	numberColor: `#bd93f9`,
}

export default highlightCodeTheme
